export default __webpack_public_path__ + "static/nested-grid-dark-a7e9ec260506ea127be83527225b6144e6c55c80d449d45cc06c409005df2a7a.png";